import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 16px;
  height: 16px;
  color: #000000;
`

const Infinite = ({ title = 'Infinite', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 16 16" title={title} {...rest}>
    <path
      fill="none"
      strokeLinecap="square"
      strokeMiterlimit={10}
      d="M15.5 8a2.727 2.727 0 01-2.727 2.727C11.068 10.727 9.364 9.364 8 8S4.932 5.273 3.227 5.273a2.727 2.727 0 000 5.454C4.932 10.727 6.636 9.364 8 8s3.068-2.727 4.773-2.727A2.727 2.727 0 0115.5 8z"
      stroke="currentColor"
    />
  </StyledIcon>
)

Infinite.displayName = 'Infinite'
Infinite.needsWork = true
export default Infinite
